import { proxy } from 'valtio'

export const useMonitorSelectionStore = proxy({
  baseContributionPointIsToday: false,
  baseRefIsTodayOpen: false,
  isRealtimeStatus: false,
  disableSelection: false,
  symbolCount: 50,
})
